export function ModalHeader({ title, onCancelAction }) {
  return (
    <div className="mt-4 mx-7 text-left flex justify-between items-center border-b border-dashed pb-1">
      <h3
        className="text-base font-semibold uppercase leading-6 text-gray-900"
        id="modal-title"
      >
        {title}
      </h3>
      <button
        className="bg-gray-100 text-gray rounded-full p-1.5 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        onClick={onCancelAction}
      >
        <svg
          className="h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>
  );
}
